import { render, staticRenderFns } from "./InstructionSelector.vue?vue&type=template&id=6f3ac7dd&"
import script from "./InstructionSelector.vue?vue&type=script&lang=js&"
export * from "./InstructionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports